export const ACCESS_TOKEN = 'access_token';
export const ACCESS_ROLE = 'access_role';
export const NON_INDIVIDUAL_PAN_ERROR =
  'Cannot proceed, you have entered a Non-Individual PAN';
export const HEADER_TEXT_PANCHECK = 'Just a moment';
export const MESSAGE_TEXT_PANCHECK = 'Checking our records...';
export const AUTHORIZATION = 'Authorization';
export const BEARER_TOKEN_PREFIX = 'Bearer ';
export const BANK_VALIDATE_POPUP_SUCCESS_MESSAGE =
  'Bank Account Verified Successfully';
export const BANK_VALIDATE_POPUP_SUCCESS_SMALL_MESSAGE = '';
export const BANK_VALIDATE_POPUP_ERROR_MESSAGE = 'Verification Pending';
export const BANK_VALIDATE_POPUP_ERROR_SMALL_MESSAGE =
  'Will be done before onboarding';
export const COMMITMENT_MINIMUM_AMOUNT = 10000000; // 1crore
export const F2_COMMITMENT_MINIMUM_AMOUNT_NI = 10000000; // 1crore
export const F2_COMMITMENT_MINIMUM_AMOUNT_IN = 1000000; // 25 Lakhs
export const F13_COMMITMENT_MINIMUM_AMOUNT = 10000000; // 1crore
export const MINIMUM_E1_CLASS_AMOUNT = 50000000;
export const SPONSOR_ENTITY_PAN = 'AABCE9810G'
export const SITE_KEY = '6Lc_rQAqAAAAALb5Ext1qCksTEwSkD4f6iTAsC4C';
export const SITE_KEY_LIVE = '6Lc_rQAqAAAAALb5Ext1qCksTEwSkD4f6iTAsC4C';
// export const SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
// export const SITE_KEY_LIVE = '6LdyNiMaAAAAAOrTPPKz88lrqG4kIAomYwoH3hrf'; //'6LfdGq4ZAAAAAGfy4ottlylNHSTnHhcTjtJJwZUx'; // Live
//export const F2 = 'FUND503';
// export const F2 = 'FUND240';
// export const F1 = 'FUND240';

// export const F1 = 'FUND501';
// export const F2 = 'FUND503';
// export const F3 = 'FUND505';

export const F1 = 'FUND229';
export const F2 = 'FUND240';
export const F3 = 'FUND242';
export const F4 = 'FUND242';
//export const F4 = 'FUND252';
export const F5 = 'FUND256';
export const F6 = 'FUND260';
export const F7 = 'FUND342';
export const F8 = 'FUND359';
export const F9 = 'FUND372';
export const F10 = 'FUND373';  //IRF
export const F11 = 'FUND375'; //GEF
export const F12 = 'FUND374'; //ISOF
export const F13 = 'FUND394'; //Discovery II
export const F14 = 'FUND399'; //ISAF IV
export const F15 = 'FUND402'; //IYP III

export const CF1 = 'FUND232';
export const CF2 = 'FUND239';
export const CF3 = 'FUND241';
export const CF4 = 'FUND252';
export const CF5 = 'FUND255';
export const CF6 = 'FUND261';
export const CF7 = 'FUND343';
export const CF8 = 'FUND360';
export const CF9 = 'FUND368';
export const CF10 = 'FUND369';
export const CF11 = 'FUND371';
export const CF12 = 'FUND370';
export const CF13 = 'FUND395';
export const CF14 = 'FUND400'; //ISAF IV
export const CF15 = 'FUND401'; //IYPIII

export const NUVAMA_PAN = "AAACC2233N,CCRPK6964N";

export const AdminRole = '1';
export const userRole = '2';
export const ExoRole = '3';

export const ParentURL = "https://dwaruat.edelweissalternatives.com/dashboard";
export const Domain = "https://dwaruat.edelweissalternatives.com";
export const CurrentURL = "https://pdswiftuat.edelweissalternatives.com/v2/dashboard";

// Development and Uat
export const NPO_DEFINITION_HEADING = 'NPO Definition';
export const NPO_DEFINITION_BODY = `
Select Yes , if you are a Non-profit organization [NPO] which has been 
constituted for religious or charitable purposes referred to in 
clause (15) of section 2 of the Income-tax Act, 1961 (43 of 1961), 
and is registered as a trust or a society under the Societies Registration Act, 
1860 (21 of 1860) or any similar State legislation or a Company registered under the 
sec on 8 of the Companies Act, 2013 (18 of 2013)
`;

export const DUE_DILIGENCE_HEADING = 'Due Diligence';
export const DUE_DILIGENCE_BODY = `With reference to SEBI circular dated October 08, 2024 (“SEBI Circular”) on 
‘Specific due diligence of investors and investments of AIFs’ to prevent facilitation of circumvention of such laws from time to 
time and implementation standards formulated by Standard Setting Forum for AIFs (“SFA”) dated October 09, 2024 and any amendment 
thereto and with reference to RBI direction on Reserve Bank of India (Investment in AIF) Directions, 2025 including any amendment 
thereto, we seek below confirmation information to carry out necessary due diligence as per the regulatory requirements.`;